'use client';
import { Box, Button, TextField, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface MobileSharesInputProps {
  shares: string;
  onSharesChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onQuickAmount: (amount: number) => void;
}

export function MobileSharesInput({
  shares,
  onSharesChange,
  onQuickAmount,
}: MobileSharesInputProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
          {t('trade.shares')}
        </Typography>
        <TextField
          value={shares}
          onChange={onSharesChange}
          placeholder="0"
          variant="outlined"
          size="small"
          InputProps={{
            inputProps: {
              inputMode: 'numeric',
              pattern: '[0-9]*',
            },
          }}
          sx={{
            width: 120,
            '& input': {
              color: 'text.primary',
            },
            '& .MuiOutlinedInput-root': {
              fontSize: '0.875rem',
              '& fieldset': {
                borderColor: 'divider',
              },
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
        />
      </Box>
      {/* Quick Share Buttons */}
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {[-100, -10, 10, 100, 200].map((amount) => (
          <Button
            key={amount}
            variant="outlined"
            onClick={() => onQuickAmount(amount)}
            sx={{
              minWidth: 'auto',
              px: 1.5,
              py: 0.5,
              borderRadius: '6px',
              textTransform: 'none',
              fontSize: '0.8125rem',
              fontWeight: 600,
              borderColor: 'divider',
              color: 'text.secondary',
              '&:hover': {
                borderColor: 'primary.main',
                color: 'primary.main',
                bgcolor: 'action.hover',
              },
            }}
          >
            {amount > 0 ? '+' : ''}
            {amount}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
